import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { RichTextSection } from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { DownloadFileFormat } from 'design-comuni-plone-theme/components/ItaliaTheme/View';
import { Card, CardBody, CardTitle } from 'design-react-kit';

const messages = defineMessages({
  scarica: {
    id: 'pubblicazione_scarica',
    defaultMessage: 'Scarica la pubblicazione',
  },
});

const PubblicazioneDownload = ({ content }) => {
  const intl = useIntl();
  return content?.publicationFile ? (
    <RichTextSection
      title={intl.formatMessage(messages.scarica)}
      tag_id="publication_download"
    >
      <div className="card-wrapper card-teaser-wrapper card-teaser-wrapper-equal">
        <Card
          className="card card-teaser shadow p-4 mt-3 rounded"
          noWrapper={true}
          tag="div"
        >
          <CardBody tag="div">
            <div className="download-formats">
              <DownloadFileFormat
                file={{
                  ...content?.publicationFile,
                  enhanced_links_enabled: true,
                }}
                showLabel={true}
                title={intl.formatMessage(messages.scarica)}
                hideFileFormatLabel={true}
                className="mb-4"
              />
            </div>
          </CardBody>
        </Card>
      </div>
    </RichTextSection>
  ) : null;
};

export default PubblicazioneDownload;
